export const dashboardHeading = {
  formation_request: 'Welcome to your dashboard. Let’s keep the ball rolling.',
  formation_request_incomplete: 'Welcome to your dashboard. Let’s keep the ball rolling.',
  order_received: 'Your formation is now in our queue.',
  accuracy_check: 'Your formation is getting checked for accuracy.',
  accuracy_check_fixing_issue: 'Our accuracy check found an issue with your formation.',
  submitted_to_state: 'Your formation is submitted to the state.',
  submitted_to_state_still_waiting: 'Your formation is submitted to the state.',
  under_state_review_delayed: 'There are delays with your formation at the state.',
  under_state_review: 'Your formation is under state review.',
  business_formed_ffd: 'Your formation is ready. We’re just waiting on your filing date.',
  business_formed_ffd_complete: 'Congrats! 🎉 Your formation is complete.',
  business_formed: 'Congrats! 🎉 Your formation is complete.',
  default: 'Welcome to your business dashboard.',
  paused: 'Your formation’s on pause.',
  business_formed_ffd_post_incomplete: 'Your paperwork has been submitted, but your formation is delayed.'
};

export const dashboardWarning = {
  under_state_review_delayed: 'Not-great news. There’s been a slow-down with your formation, due to circumstances out of our control. We’ll keep you informed. ',
  submitted_to_state_still_waiting: 'Your formation’s sitting in some gloomy government office. We didn’t want to leave you hanging. Just a bit longer to wait. ',
  accuracy_check_fixing_issue: 'We caught something off in your formation details. Check for any emails from support@zenbusiness.com to resolve that quickly. ',
  business_formed_ffd: 'We’re waiting to officially form your business on the special day you chose for the Future Filing Date option. ',
  business_formed_ffd_post_incomplete: 'We submitted your paperwork on your selected Future Filing Date, but there\'s been a slow-down with your formation, due to circumstances out of our control. We\'ll keep you informed.',
  paused: 'Pick it back up when you’re ready by emailing support@zenbusiness.com.'
};

export const MODAL_PARAM_KEY = 'm';

export const PRODUCT_MODALS = {
  AMENDMENT: 'amendment',
  ANNUAL_REPORT: 'annualReport',
  BANKING_RESOLUTION_TEMPLATE: 'bankingResolutionTemplate',
  ZB_CHECKING_PREFERRED: 'checkingPreferred',
  BANK_OF_AMERICA_OFFER: 'bankOfAmericaOffer',
  BUSINESS_BANK_ACCOUNT: 'businessBankAccount',
  BUSINESS_DOCUMENTS: 'businessDocuments',
  BUSINESS_LICENSE_REPORT: 'businessLicenseReport',
  CORP_BUSINESS_KIT: 'corpBusinessKit',
  CORP_BYLAWS: 'corporateBylaws',
  DBA_ENTITY: 'dbaEntity',
  DOMAIN_NAME_PRIVACY: 'domainNamePrivacy',
  DOMAIN_NAME_REG: 'domainNameReg',
  EIN_CREATION: 'einCreation',
  EMAIL: 'email',
  ENTITY_NAME_RESERVATION: 'entityNameReservation',
  GRANT_APPLICATION: 'grantApplication',
  LLC_BUSINESS_KIT: 'llcBusinessKit',
  NY_PUBLICATION: 'nyPublication',
  ONLINE_NOTARY_SERVICE: 'onlineNotaryService',
  OPERATING_AGREEMENT: 'operatingAgreement',
  STANDARD_GOOD_STANDING: 'standardGoodStanding',
  WFG_INITIAL_REPORT: 'wfgInitialReport',
  WEBSITE: 'website',
  WEBSITE_DUDA: 'websiteDuda',
  WORRY_FREE_SERVICE: 'worryFreeService',
  ZEN_BUSINESS_MONEY: 'zenBusinessMoney'
};

export const DBA_IGNORE_STATES = [
  'AL',
  'AK',
  'AZ',
  'AR',
  'CA',
  'CT',
  'DC',
  'DE',
  'FL',
  'GA',
  'HI',
  'KS',
  'KY',
  'LA',
  'MA',
  'MD',
  'MN',
  'NC',
  'ND',
  'NE',
  'NM',
  'NV',
  'PA',
  'SC',
  'TN',
  'VA',
  'VT',
  'WA',
  'WI',
  'WV',
  'WY'
];

// keeping this key name for legacy reasons
export const BUSINESS_CARD_OFFER_STORAGE_KEY = 'zb.upsell.Chase.CreditCards';

export const HAS_STARTED_EDUCATION_STORIES = 'hasStartedEducationStories';

export const HAS_STARTED_INVOICE_STORIES = 'hasStartedInvoiceStories';
